import { Sensitivity, SensitivityCategory } from "~/api";

export const sensitivityOptionsDictionary: Record<string, Sensitivity> = {
  "Health Level 1": {
    category: SensitivityCategory.HEALTH,
    level: 1,
  },
  "Health Level 2": {
    category: SensitivityCategory.HEALTH,
    level: 2,
  },
  "Health Level 3": {
    category: SensitivityCategory.HEALTH,
    level: 3,
  },
  "Financial Level 1": {
    category: SensitivityCategory.FINANCIAL,
    level: 1,
  },
  "Financial Level 2": {
    category: SensitivityCategory.FINANCIAL,
    level: 2,
  },
  "Financial Level 3": {
    category: SensitivityCategory.FINANCIAL,
    level: 3,
  },
  "Personal Level 1": {
    category: SensitivityCategory.PERSONAL,
    level: 1,
  },
  "Personal Level 2": {
    category: SensitivityCategory.PERSONAL,
    level: 2,
  },
  "Personal Level 3": {
    category: SensitivityCategory.PERSONAL,
    level: 3,
  },
};
